function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import { Transforms, Element as SlateElement, Text } from 'slate';
var allowedUrlSchemes = ['http:', 'https:', 'mailto:', 'tel:'];
function getSafeUrl(href) {
  if (!href) {
    return 'about:blank';
  }
  try {
    var parsed = new URL(href, 'http://localhost');
    if (!parsed.host && href.startsWith('/')) {
      return href;
    }
    return allowedUrlSchemes.includes(parsed.protocol) ? parsed.href : 'about:blank';
  } catch (_unused) {
    if (href.startsWith('/')) {
      return href;
    }
    return 'about:blank';
  }
}
function flatten(items) {
  var result = [];
  var _iterator = _createForOfIteratorHelper(items),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (Array.isArray(item)) {
        result.push.apply(result, _toConsumableArray(flatten(item)));
      } else {
        result.push(item);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
}
function normalizeChildren(nodes) {
  var flat = flatten(nodes);
  return flat.map(function (child) {
    if (typeof child === 'string') {
      return {
        text: child
      };
    }
    if (child && _typeof(child) === 'object') {
      return child;
    }
    return {
      text: ''
    };
  });
}
function applyMarks(nodes, marks) {
  return nodes.map(function (node) {
    if (Text.isText(node)) {
      return _objectSpread(_objectSpread({}, node), marks);
    }
    if (SlateElement.isElement(node)) {
      var element = node;
      var children = applyMarks(element.children, marks);
      return _objectSpread(_objectSpread({}, element), {}, {
        children: children
      });
    }
    return node;
  });
}
var ELEMENT_TAGS = {
  A: function A(el) {
    return {
      type: 'link',
      url: getSafeUrl(el.getAttribute('href'))
    };
  },
  BLOCKQUOTE: function BLOCKQUOTE() {
    return {
      type: 'blockquote'
    };
  },
  H1: function H1() {
    return {
      type: 'heading',
      depth: 1
    };
  },
  H2: function H2() {
    return {
      type: 'heading',
      depth: 2
    };
  },
  H3: function H3() {
    return {
      type: 'heading',
      depth: 3
    };
  },
  H4: function H4() {
    return {
      type: 'heading',
      depth: 4
    };
  },
  H5: function H5() {
    return {
      type: 'heading',
      depth: 5
    };
  },
  H6: function H6() {
    return {
      type: 'heading',
      depth: 6
    };
  },
  LI: function LI() {
    return {
      type: 'li'
    };
  },
  OL: function OL() {
    return {
      type: 'ol'
    };
  },
  P: function P() {
    return {
      type: 'paragraph'
    };
  },
  UL: function UL() {
    return {
      type: 'ul'
    };
  }
};
var TEXT_TAGS = {
  CODE: function CODE() {
    return {
      code: true
    };
  },
  DEL: function DEL() {
    return {
      strikethrough: true
    };
  },
  EM: function EM() {
    return {
      emphasis: true
    };
  },
  I: function I() {
    return {
      emphasis: true
    };
  },
  S: function S() {
    return {
      strikethrough: true
    };
  },
  STRONG: function STRONG() {
    return {
      strong: true
    };
  },
  B: function B() {
    return {
      strong: true
    };
  },
  U: function U() {
    return {
      underline: true
    };
  }
};
function deserializeNode(el) {
  if (el.nodeType === 3) {
    var _el$textContent;
    return (_el$textContent = el.textContent) !== null && _el$textContent !== void 0 ? _el$textContent : '';
  }
  if (el.nodeType !== 1) {
    return null;
  }
  var element = el;
  if (element.nodeName === 'BR') {
    return '\n';
  }
  var parent = element;
  if (parent.nodeName === 'PRE' && parent.childNodes[0] && parent.childNodes[0].nodeName === 'CODE') {
    parent = parent.childNodes[0];
  }
  var children = Array.from(parent.childNodes).map(deserializeNode);
  if (children.length === 0) {
    children = [{
      text: ''
    }];
  }
  if (element.nodeName === 'BODY') {
    return normalizeChildren(children);
  }
  var nodeName = element.nodeName;
  if (ELEMENT_TAGS[nodeName]) {
    var attrs = ELEMENT_TAGS[nodeName](element);
    return _objectSpread(_objectSpread({}, attrs), {}, {
      children: normalizeChildren(children)
    });
  }
  if (TEXT_TAGS[nodeName]) {
    var _attrs = TEXT_TAGS[nodeName]();
    var normalized = normalizeChildren(children);
    return applyMarks(normalized, _attrs);
  }
  return normalizeChildren(children);
}
export function convertHtmlToSlateTree(html) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(html, 'text/html');
  var body = doc.body;
  var result = deserializeNode(body);
  return Array.isArray(result) ? result : [result];
}
function capHeadingLevels(fragment, maxHeadingLevel) {
  function transform(node) {
    if (SlateElement.isElement(node)) {
      var element = node;
      var nextChildren = element.children.map(transform);
      if (element.type === 'heading' && typeof element.depth === 'number') {
        var cappedDepth = Math.min(element.depth, maxHeadingLevel);
        if (cappedDepth !== element.depth) {
          return _objectSpread(_objectSpread({}, element), {}, {
            depth: cappedDepth,
            children: nextChildren
          });
        }
      }
      return _objectSpread(_objectSpread({}, element), {}, {
        children: nextChildren
      });
    }
    return node;
  }
  return fragment.map(transform);
}
function stripHeadings(fragment) {
  function transform(node) {
    if (SlateElement.isElement(node)) {
      var element = node;
      var nextChildren = element.children.map(transform);
      if (element.type === 'heading') {
        return {
          type: 'paragraph',
          children: nextChildren
        };
      }
      return _objectSpread(_objectSpread({}, element), {}, {
        children: nextChildren
      });
    }
    return node;
  }
  return fragment.map(transform);
}
export function withHtmlPaste(editor, options) {
  var originalInsertData = typeof editor.insertData === 'function' ? editor.insertData.bind(editor) : undefined;
  editor.insertData = function (data) {
    var html = data.getData('text/html');
    if (html) {
      var slateTree = convertHtmlToSlateTree(html);
      var headingsAllowed = (options === null || options === void 0 ? void 0 : options.allowHeadings) !== false;
      var adjusted = headingsAllowed ? options !== null && options !== void 0 && options.maxHeadingLevel ? capHeadingLevels(slateTree, options.maxHeadingLevel) : slateTree : stripHeadings(slateTree);
      Transforms.insertFragment(editor, adjusted);
      return;
    }
    // Fallback to default behavior (plain text or other data types)
    if (originalInsertData) {
      originalInsertData(data);
    }
  };
  return editor;
}